import {ChickEntity, getChickEntityById} from "./config/ChickConfig";
import {ChickenCacheEntity} from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import O1HD from "../../../../engines/gameEngine";
import gameConfig from "../../../../engines/configs/gameConfig";
import { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";

const {ccclass, property} = cc._decorator;

/**
 * 鸡 预制体
 */
@ccclass
export default class ChickenItemPrefab extends cc.Component {

    @property({ type:sp.Skeleton,displayName:"小鸡sp"})
    youngChickenSp : sp.Skeleton = null;
    @property(sp.Skeleton)
    chickenSp : sp.Skeleton = null;
    @property(sp.SkeletonData)
    chickenSkeletonData : sp.SkeletonData[] = [];
    @property(cc.Node)
    touchNode : cc.Node = null;
    @property(sp.Skeleton)
    featherSp : sp.Skeleton = null;
    @property(sp.Skeleton)
    efChangeSp : sp.Skeleton = null;
    @property(cc.Label)
    lbTalkMsg : cc.Label = null;

    private readonly rangerArray : number[] = [100,200,300];
    private readonly speedArray : number[] = [40,80,120];
    private readonly weightArray : number[] = [15,10,5,70];

    private mChickCacheEntity : ChickenCacheEntity;
    private mChickEntity : ChickEntity;
    //是否拎起
    private carryingFlag : boolean = false;

    onLoad () {
        this.touchNode.on("touchstart" , this.touchStart , this );
        this.touchNode.on("touchmove" , this.touchMove , this );
        this.touchNode.on("touchcancel" , this.touchCancel , this );
        this.touchNode.on("touchend" , this.touchEnd , this );
    }

    start () {
    }

    touchStart( e : cc.Event.EventTouch ){
        if ( this.carryingFlag == false ){
            O1HD.getManagers().soundMgr.playSound("chickDrag", null, BUNDLE_SMALL_NAME.chickenBundle);
            this.carryingFlag = true;
            this.youngChickenSp.setCompleteListener(()=>{});
            this.chickenSp.setCompleteListener(()=>{});
            cc.Tween.stopAllByTarget( this.node );
            // cc.Tween.stopAllByTag(1);
            if ( this.youngChickenSp.node.active ) {
                this.youngChickenSp.setCompleteListener(()=>{
                    this.youngChickenSp.setCompleteListener(()=>{});
                    this.youngChickenSp.setAnimation( 0 ,"UP_02",true );
                });
                this.youngChickenSp.setAnimation( 0 , "UP_01" , false );
            }else{
                this.chickenSp.setCompleteListener(()=>{
                   this.chickenSp.setCompleteListener(()=>{});
                   this.chickenSp.setAnimation( 0 ,"Up_02",true );
                });
                this.chickenSp.setAnimation( 0 , "Up_01" , false );
            }
        }
    }

    touchMove( e : cc.Event.EventTouch ){
        if ( this.carryingFlag ){
            this.node.x += e.getDeltaX();
            this.node.y += e.getDeltaY();
        }
    }
    touchCancel( e : cc.Event.EventTouch ){
        this.carryingFlag = false;
        this._checkRecycle();
    }
    touchEnd( e : cc.Event.EventTouch ){
        this.carryingFlag = false;
        this._checkRecycle();
    }

    private _checkRecycle(){
        //检查是否回收
        O1HD.emit("ChickenPrefab.checkHoleNode" , this.node.convertToWorldSpaceAR(cc.v2()) , ( ret : boolean )=>{
            if ( ret ) {
                if ( this.youngChickenSp.node.active ) {
                    //年轻
                    this._chickFallDown( this.youngChickenSp.node );
                }else{
                    //成年鸡
                    this._chickFallDown( this.chickenSp.node );
                }
            }else{
                this.scheduleAni();
            }
        });
    }

    private _chickFallDown( node : cc.Node ){
        let scale = node.scaleX > 0 ? 0.2 : -0.2;
        cc.tween( node )
            .to( 0.5, { scaleX : scale , scaleY : 0.2 , y : -20 })
            .call(()=>{
                O1HD.getManagers().soundMgr.playSound("takeAwayHole").then();
                let findIndex = NormalGameManager._instance.getGameData().chickenData.findIndex(( item , index , dataList )=>{
                    return item.uniqueId == this.mChickCacheEntity.uniqueId;
                });
                NormalGameManager._instance.getGameData().chickenData.splice( findIndex , 1 );
                NormalGameManager._instance.writeGameData();

                // 加钱
                O1HD.emit("ChickenPrefab.recycleHoleMoney" , this.mChickEntity.recyclePrice );
                node.active = false;
                this.featherSp.node.active = true;
                this.featherSp.setCompleteListener(()=>{
                    this.node.removeFromParent();
                    this.node.destroy();
                });
                this.featherSp.setAnimation( 0 , "animation" , false );
            })
            .start();
    }

    /**
     *  鸡 ，鸡的大小
     */
    bindData( chickEntity : ChickenCacheEntity ){
        this.mChickCacheEntity = chickEntity;
        this.refreshData();
    }

    refreshData(){
        this.mChickEntity = getChickEntityById( this.mChickCacheEntity.chickenId);
        if ( !this.mChickEntity ) {
            return;
        }
        if ( this.mChickEntity.becomeBigId ) {
            //小鸡
            this.youngChickenSp.node.active = true;
            this.scheduleOnce(()=>{
                this.youngChickenSp.setSkin( this.mChickEntity.imgPath );
                this.youngChickenSp.setToSetupPose();
                this.youngChickenSp.setCompleteListener(()=>{
                    this.scheduleAni();
                    this.youngChickenSp.setCompleteListener(()=>{});
                });
                this.youngChickenSp.setAnimation( 0 ,"Jump" , false );
            });
        }else{
            //成年鸡
            this.chickenSp.node.active = true;
            this.scheduleOnce(()=>{
                switch ( this.mChickEntity.id ) {
                    case 2 : this.chickenSp.skeletonData = this.chickenSkeletonData[1];break;
                    case 4 : this.chickenSp.skeletonData = this.chickenSkeletonData[2];break;
                    case 6 : this.chickenSp.skeletonData = this.chickenSkeletonData[0];break;
                    case 8 : this.chickenSp.skeletonData = this.chickenSkeletonData[3];break;
                    case 9 : this.chickenSp.skeletonData = this.chickenSkeletonData[4];break;
                    case 10 :this.chickenSp.skeletonData = this.chickenSkeletonData[5];break;
                }
                this.chickenSp.setCompleteListener(()=>{
                    this.scheduleAni();
                    this.chickenSp.setCompleteListener(()=>{});
                });
                this.chickenSp.setAnimation( 0 ,"Jump" , false );
            });
        }
    }

    /**
     * 开始动画
     */
    scheduleAni(){
        if( this.carryingFlag ) {
            return;
        }
        cc.Tween.stopAllByTarget( this.node );
        if ( !this.mChickEntity ) {
             return;
        }
        // 判断是否 变大
        if ( this.mChickEntity.becomeBigId ) {
            let hour = NormalGameManager._instance.mGameHours - this.mChickCacheEntity.bornGameHour;
            let minute = NormalGameManager._instance.mMinute - this.mChickCacheEntity.bornGameMinute;
            let hasLiveSeconds = hour * 10 + Math.floor( minute / 6 ) * 1;
            if ( hasLiveSeconds >= this.mChickEntity.becomeBigSeconds ) {
                // 变大
                this.becomeBig();
                return;
            }
        }
        // 判断是否下蛋
        if( !this.mChickEntity.becomeBigId && this.mChickEntity.eggWeightArray ){
            let hour = NormalGameManager._instance.mGameHours - this.mChickCacheEntity.lastLayHour;
            let minute = NormalGameManager._instance.mMinute - this.mChickCacheEntity.lastLayMinute;
            let hasLiveSeconds = hour * 10 + Math.floor( minute / 6 ) * 1;
            if ( hasLiveSeconds >= this.mChickEntity.layingEggSeconds ) {
                // 变大
                this.chickenSp.setAnimation( 0 , "Move_02" , true );
                this.layingEgg();
                return;
            }
        }
        let randomIndex = this._getRandomIndex();
        switch ( randomIndex ) {
            //散步
            case 0:this.takeAWalk();break;
            //溜达
            case 1:this.walkAround();break;
            //徘徊
            case 2:this.wander();break;
            case 3:this.standby();break;
        }
    }

    /**
     * 生蛋
     */
    layingEgg(){
        let weightAll : number = 0 ;
        for ( let eggWeight of this.mChickEntity.eggWeightArray ) {
            weightAll += eggWeight.weight;
        }
        let randomNum = Math.floor( Math.random() * weightAll );
        let eggId : number = 0;
        for ( let eggWeight of this.mChickEntity.eggWeightArray ) {
            if ( randomNum <= eggWeight.weight ){
                eggId = eggWeight.goodsId;
                break;
            }
            randomNum -= eggWeight.weight;
        }
        let pos : cc.Vec2 = cc.v2( -180 ,250 );
        let skin : string;
        switch ( eggId ) {
            case 21001:pos = cc.v2( -180 ,250 );skin="PuTong";break;
            case 21002:pos = cc.v2( 160 ,250 );skin="Yin";break;
            case 21003:pos = cc.v2( -180 ,35 );skin="Jin";break;
            case 21004:pos = cc.v2( 160 ,35 );skin="KongNiao";break;
            case 21005:pos = cc.v2( -180 ,-206 );skin="FongHuang";break;
            case 21006:pos = cc.v2( 160 ,-206 );skin="QiLin";break;
        }

        //切换皮肤
        this.scheduleOnce(()=>{
            this.chickenSp.setSkin( skin );
            this.chickenSp.setToSetupPose();
        });

        let direction = pos.x > this.node.x ? -0.5 : 0.5;
        let needSeconds : number = pos.sub( this.node.getPosition(cc.v2()) ).mag() / this.speedArray[1];
        this.chickenSp.node.scaleX = direction;
        cc.tween( this.node )
            .to(needSeconds,{ x : pos.x , y : pos.y })
            .call(()=>{
                if ( this.mChickEntity.id == 10 || this.mChickEntity.id == 9 ) {
                    this.chickenSp.setAnimation( 0 , "Idle" , true );
                }else{
                    this.chickenSp.setAnimation( 0 , "Idle_01" , true );
                }
            })
            .delay( 1 )
            .call(()=>{
                // 判断是否可以下蛋
                let nestCacheData = NormalGameManager._instance.getGameData().chickenCoop.nestData.find(( item ,index ,datalist )=>{
                    return item.goodsId == eggId;
                });
                if ( nestCacheData && nestCacheData.count >= gameConfig.NEST_EGG_COUNT ) {
                    this.chickenSp.setCompleteListener( ()=>{  } );
                    //不能下蛋 鸡说话
                    this._chickenTalk();
                    this.mChickCacheEntity.lastLayHour = NormalGameManager._instance.mGameHours;
                    this.mChickCacheEntity.lastLayMinute = NormalGameManager._instance.mMinute;
                    NormalGameManager._instance.writeGameData();
                    this.scheduleAni();
                }else{
                    //开始下蛋
                    this.chickenSp.setCompleteListener(()=>{
                        O1HD.emit("NestNode.addEggs" , eggId );
                        this.mChickCacheEntity.lastLayHour = NormalGameManager._instance.mGameHours;
                        this.mChickCacheEntity.lastLayMinute = NormalGameManager._instance.mMinute;
                        NormalGameManager._instance.writeGameData();
                        this.chickenSp.setCompleteListener( ()=>{  } );
                        this.scheduleAni();
                    });
                    this.chickenSp.setAnimation( 0 , "Laying" , false );
                }
            })
            .start();
    }

    private readonly chickenTalkMsgArray : string[] = [
        "蛋满了啊，下个屁啊！",
        "真懒，蛋都不收，不生了！",
        "我服了！这怎么下蛋！",
        "钱都不要了吗？",
        "哎，我的子孙又得延后了！",
        "怎么办事的啊，快来收啊！",
    ];
    /**
     * 鸡说话
     * @private
     */
    private _chickenTalk( ){
        let randomIndex = Math.floor( Math.random() * this.chickenTalkMsgArray.length );
        this.lbTalkMsg.string = `${this.chickenTalkMsgArray[randomIndex]}`;
        this.lbTalkMsg.node.parent.active = true;
        this.scheduleOnce(()=>{
            this.lbTalkMsg.node.parent.active = false;
        },2 );
    }

    /**
     * 变大
     */
    becomeBig(){
        this.mChickCacheEntity.lastLayHour = NormalGameManager._instance.mGameHours;
        this.mChickCacheEntity.lastLayMinute = NormalGameManager._instance.mMinute;
        this.mChickCacheEntity.chickenId = this.mChickEntity.becomeBigId;
        NormalGameManager._instance.writeGameData();
        this.youngChickenSp.node.active = false;
        this.efChangeSp.node.active = true;
        this.efChangeSp.setAnimation( 0 , "animation" , false );
        this.refreshData();
    }


    /**
     * 散步
     * 范围 100 半径
     */
    takeAWalk(  ){
        let sp = this.youngChickenSp.node.active ? this.youngChickenSp : this.chickenSp;
        sp.setAnimation( 0 , "Move_01" , true );
        this.startAni( 0 );
    }

    /**
     * 溜达
     * 范围 300
     */
    walkAround(){
        let sp = this.youngChickenSp.node.active ? this.youngChickenSp : this.chickenSp;
        sp.setAnimation( 0 , "Move_01" , true );
        this.startAni( 1 );
    }

    /**
     * 徘徊
     */
    wander(){
        let sp = this.youngChickenSp.node.active ? this.youngChickenSp : this.chickenSp;
        sp.setAnimation( 0 , "Move_02" , true );
        this.startAni( 2 );
    }

    startAni( index : number ){
        let range = this.rangerArray[index];
        let speed : number = this.speedArray[index];
        let correctionInfo : { correctionX : number , correctionY : number } = this._getCorrectionInfo( range );
        let randomX : number = Math.floor( Math.random() * range * 2 ) - range + correctionInfo.correctionX + this.node.x;
        let direction = randomX > this.node.x ? -0.5 : 0.5;
        let randomY : number = Math.floor( Math.random() * range * 2 ) - range + correctionInfo.correctionY + this.node.y;
        let needSeconds : number = cc.v2( randomX , randomY ).sub( this.node.getPosition(cc.v2()) ).mag() / speed;
        let sp = this.youngChickenSp.node.active ? this.youngChickenSp : this.chickenSp;
        sp.node.scaleX = direction;
        // cc.Tween.stopAllByTarget(this.node);
        cc.tween( this.node )
            .to(needSeconds,{ x : randomX , y : randomY })
            .call(()=>{
                if ( this.mChickEntity.id == 10 || this.mChickEntity.id == 9  ) {
                    sp.setAnimation( 0 , "Idle" , true );
                }else{
                    sp.setAnimation( 0 , "Idle_01" , true );
                }
            })
            .delay(1)
            .call(()=>{
                this.scheduleAni();
            })
            .start();
    }

    /**
     * 获得校正逻辑
     * @param range
     */
    private _getCorrectionInfo ( range : number ) : { correctionX : number , correctionY : number }{
        let correctionX : number = 0;
        let correctionY : number = 0;
        let currX = 300 - range - Math.abs( this.node.x ) ;
        if ( currX < 0 ) {
            correctionX = this.node.x < 0 ? -currX : currX;
        }
        let currY = 300 - range - Math.abs( this.node.y );
        if ( currY < 0 ) {
            correctionY = this.node.y < 0 ? -currY : currY;
        }
        return { correctionX : correctionX , correctionY : correctionY };
    }

    /**
     * 获取随机下标
     * @private
     */
    private _getRandomIndex() : number{
        let randomNum = Math.floor( Math.random() * 100 );
        for ( let i = 0 ;  i < this.weightArray.length; i ++ ) {
            if ( randomNum <= this.weightArray[i] ) {
                return i ;
            }
            randomNum -= this.weightArray[i];
        }
        return 0;
    }

    /**
     * 待机
     */
    standby(){
        if ( this.mChickEntity.id == 9 || this.mChickEntity.id == 10 ) {
            this.chickenSp.setAnimation( 0 , "Idle" , true );
        }else{
            let sp = this.youngChickenSp.node.active ? this.youngChickenSp : this.chickenSp;
            if ( this.mChickEntity.id == 10 || this.mChickEntity.id == 9  ) {
                sp.setAnimation( 0 , "Idle" , true );
            }else{
                sp.setAnimation( 0 , "Idle_01" , true );
            }
        }
        this.scheduleOnce(()=>{
            this.scheduleAni();
        },2 );
    }

    update (dt) {
        this.node.zIndex = -this.node.y;
    }
}
